import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { IconButton } from '../../atoms/iconButton/IconButton'
import { ThumbDirection, ThumbIcon } from '../../atoms/icons/ThumbIcon'
import { tID } from '../../utils/utils'

const Container = styled.View(({ theme }) => ({
  flexDirection: 'row',
  marginTop: theme.spacing['4px'],
}))

export interface MessageFeedbackProps {
  onPress: (value: string | null) => void
  value?: string
}

enum FeedbackValue {
  UP = '1',
  DOWN = '0',
}

export const MessageFeedback: FunctionComponent<MessageFeedbackProps> = ({ onPress, value = 0 }) => {
  const { formatMessage } = useIntl()
  const { colors } = useTheme()
  const upSelected = value === FeedbackValue.UP
  const downSelected = value === FeedbackValue.DOWN

  const handlePress = (val: string | null) => {
    onPress(val)
  }

  return (
    <Container testID={tID('MessageFeedback')}>
      <IconButton
        leftIcon={<ThumbIcon isFilled={upSelected} />}
        onPress={() => handlePress(upSelected ? null : FeedbackValue.UP)}
        accessibilityLabel={formatMessage({
          defaultMessage: 'Positive Feedback',
          description: 'Button for leaving positive feedback on ai response',
        })}
        textAlign='center'
        testID={tID(`MessageFeedback-positiveButton-${upSelected ? 'selected' : 'unselected'}`)}
        iconColor={upSelected ? colors.iconActive : undefined}
      />
      <IconButton
        leftIcon={<ThumbIcon direction={ThumbDirection.DOWN} isFilled={downSelected} />}
        onPress={() => handlePress(downSelected ? null : FeedbackValue.DOWN)}
        accessibilityLabel={formatMessage({
          defaultMessage: 'Negative Feedback',
          description: 'Button for leaving negative feedback on ai response',
        })}
        textAlign='center'
        testID={tID(`MessageFeedback-negativeButton-${downSelected ? 'selected' : 'unselected'}`)}
        iconColor={downSelected ? colors.iconActive : undefined}
      />
    </Container>
  )
}
